export default "__VITE_ASSET__BDeKB$Wf__"